/**
 * Order-related constants
 * Centralized to avoid duplication across components
 */

export const STATUS_LIST = [
  {
    label: "All Status",
    color: "#12B981",
    value: "",
  },
  {
    label: "Completed",
    icon: "/checkIcon.png",
    color: "#12B981",
    value: "Completed",
  },
  {
    label: "Pending",
    icon: "/pendingIcon.png",
    color: "#FF5C1F",
    value: "Pending",
  },
  {
    label: "Canceled",
    icon: "/unCheckIcon.png",
    color: "#E20E0E",
    value: "Cancelled",
  },
];

export const STATUS_LIST_WITHOUT_ALL = STATUS_LIST.slice(1);

export const ROWS_PER_PAGE_OPTIONS = [15, 25, 50, 100];

export const ROWS_PER_PAGE_OPTIONS_DETAIL = [15, 20, 25, 30];

export const DEFAULT_ROWS_PER_PAGE = 15;

export const DEBOUNCE_DELAY = 500;

export const PAYMENT_STATUS_CONFIG = {
  active: { label: "Active", color: "success" },
  pending: { label: "Pending", color: "warning" },
  inactive: { label: "Inactive", color: "default" },
  failed: { label: "Failed", color: "error" },
};

/**
 * Get status chip props based on payment status
 */
export const getPaymentStatusChipProps = (status) => {
  const normalizedStatus = status?.toLowerCase();
  return (
    PAYMENT_STATUS_CONFIG[normalizedStatus] || {
      label: status || "Unknown",
      color: "default",
    }
  );
};

/**
 * Find status info from STATUS_LIST
 */
export const getStatusInfo = (status) => {
  return STATUS_LIST.find(
    (s) => s.value?.toLowerCase() === status?.toLowerCase()
  );
};